import { render, staticRenderFns } from "./limits.vue?vue&type=template&id=735b3fb8&scoped=true"
import script from "./limits.vue?vue&type=script&lang=js"
export * from "./limits.vue?vue&type=script&lang=js"
import style0 from "./limits.vue?vue&type=style&index=0&id=735b3fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735b3fb8",
  null
  
)

export default component.exports